import {AuthService} from 'src/app/auth/auth.service';
import {environment} from './../../environments/environment';
import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Store} from "@ngrx/store";
import {BehaviorSubject, forkJoin, Observable, of, throwError} from "rxjs";
import {catchError, map, mergeMap} from "rxjs/operators";
import Swal from "sweetalert2";
import {SignupModel} from "../models/signUp.model";
import {Endpoints} from "../shared/config/endpoints";
import {AppState} from "../store/app.state";
import {UserModel} from "../store/storeModels/user.model";
import {OrgModel} from "./../store/storeModels/user.model";
import {GeneralService} from "./general.service";

@Injectable({
  providedIn: "root",
})
export class SignupLoginService {
  otpInfo = new BehaviorSubject<any>("");
  private signupUrl = this.endpoints.signUpEndpoint;
  private peopleUrl = this.endpoints.peopleEndpoint;
  private keysUrl = environment.keysUrl;
  private adminApi = this.endpoints.adminUrl;
  private user: UserModel;
  private org: OrgModel;
  private token: string;
  private licenseExpiryWatcherStarted = false;
  constructor(
    private http: HttpClient,
    private endpoints: Endpoints,
    private gs: GeneralService,
    store: Store<AppState>,
    private authSrv: AuthService
  ) {
    store.select("userInfo").subscribe((info) => {
      if (info) {
        this.org = info.organization ? info.organization : null;
        this.user = info.user ? info.user : null;
        this.token = info.token ? info.token : null;
      }
    });
  }

  // Handle Errors
  private handleError = (error: any): Observable<any> => {
    let message = "";
    if (error) {
      if (error.error) {
        message = error.error.message;
      } else {
        message = error.message;
      }
    }
    if (message.includes("Email")) {
      Swal.fire({
        type: "error",
        title: "Oops...",
        text: "Email Already Exist!",
      });
    }
    return of(null);
  };

  // Merge Endpoints
  private get createUserUrl() {
    return this.signupUrl + this.endpoints.signUpApis.createUser;
  }
  private get getAllUsersUrl() {
    return this.signupUrl + this.endpoints.signUpApis.getAllUsers;
  }
  private get getOneUserUrl() {
    return this.signupUrl + this.endpoints.signUpApis.getOneUser;
  }

  // User Registration

  registerUser(payload: SignupModel) {
    const body = {
      ...payload,
      city: "",
      country: "",
      dateOfBirth: "",
      emailConfirm: false,
      mobileNo: "",
      phoneNo: "",
      state: "",
      street: "",
      token: "",
      website: "",
    };
    return this.http.post(this.createUserUrl, body);
  }

  getAllUsers() {
    try {
      return this.http
        .get(this.getAllUsersUrl)
        .pipe(catchError(this.handleError));
    } catch (error) {
      alert(error);
    }
  }

  verifyUser(userid) {
    return this.http.get(this.signupUrl + "/validateUser/" + userid);
  }
  getIncompleteUserDetails(id) {
    return this.http.get(this.signupUrl + "/getIncompleteUserDetails/" + id);
  }
  verifyAccount(id) {
    return this.http.get(this.signupUrl + "/validateUser/" + id);
  }
  // updateNewAccount(payload) {
  //   return this.http.post(this.signupUrl + "/update/activateUser/", payload);
  // }
  completeUserSignup(payload) {
    return this.http.post(this.signupUrl + "/completeUserSignup/", payload);
  }
  loginUser(payload: { email: string; password: string }) {
    const { email: username, password } = payload;
    return this.http.post(this.signupUrl + `/doLogin`, { username, password });
  }

  logoutUser() {
    return this.http.get(this.signupUrl + "/logout/" + this.token);
  }

  verifyOTP(payload) {
    const { username, optVal } = payload;
    return this.http.post(
      this.signupUrl + `/validateOTP/${username}/${optVal}`,
      {}
    );
  }
  getAllUserOrganizations(userID, type) {
    return this.http.get(
      this.signupUrl + `/getAllUserOrganizations/${userID}/${type}`
    );
  }
  getAUserDetails(userId, orgId, type: Number) {
    return this.http.get(
      this.signupUrl + `/getAUserDetails/${userId}/${orgId}/${type}`
    );
  }
  getUsersInOrganization(orgId) {
    return this.http.get(
      this.signupUrl + `/getOrganizationPersons/${orgId}/${1}`
    );
  }

  fetchAllUserOrg(userID, type) {
    return this.http.get(this.signupUrl + `/getAllUserOrganizations/${userID}/${type}`);
  }

  updateUser(payload) {
    const body = {
      ...this.user,
      ...payload,
      country: payload.country + "",
    };
    return this.http.post(this.signupUrl + "/editUser", body);
  }
  updateOrg(payload) {
    const body = {
      ...this.org,
      ...payload,
      country: payload.country + "",
    };
    delete body["modules"];
    return this.http.post(this.signupUrl + "/editOrganization", body);
  }
  switchTenant(orgID) {
    const body = {
      orgID: orgID,
      token: this.token,
    };
    const _url = this.signupUrl + `/${orgID}/${this.token}/switchTenant`;
    return this.http.post(_url, body);
  }

  fetchOrg(orgId) {
    let endpoint = "/Organization";
    const path = `${endpoint}/${orgId}`;
    return this.http.get(this.signupUrl + path);
  }

  generalSwitchTenant(orgID: number, token) {
    const payload = {
      orgID: orgID,
      token: token,
    };
    const _url = this.signupUrl + `/${orgID}/${token}/switchTenant`;
    return this.http.post(_url, payload);
  }
  changePwd({ opass, npass }) {
    const body = {
      username: this.user.email,
      npassword: npass,
      password: opass,
    };
    const url = `${this.signupUrl}/changePass/`;
    return this.http.post(url, body);
  }
  fetchUserPercent() {
    return this.http.get(
      this.signupUrl + `/getUserProfilePercentage/${this.user.id}`
    );
  }
  uploadUserImg(file: File, uploadType?) {
    let endpoint = "/uploadUserProfilePics";
    // endpoint =
    //   uploadType === "update" ? endpoint + "/profile-update" : endpoint;
    const fd = new FormData();
    fd.append("file", file, file.name);
    const path = `${endpoint}/${this.user.id}/`;
    return this.http.post(this.signupUrl + path, fd);
  }

  uploadOrgImg(file: File, uploadType?) {
    let endpoint = "/Organization";
    endpoint = uploadType === "update" ? "update" : endpoint;
    const fd = new FormData();
    fd.append("file", file, file.name);
    const path = `/uploadOrganizationProfilePics/${this.org.id}`;
    return this.http.post(this.signupUrl + path, fd);
  }

  addTax(body) {
    return this.http.post(this.signupUrl + "/addTax", {
      ...body,
      orgID: this.org.id,
    });
  }
  fetchTax() {
    return this.http.get(this.signupUrl + `/${this.org.id}/getTaxes`);
  }

  getAllTaxes() {
    return this.http.get(this.signupUrl + `/${this.org.id}/getAllTaxes`);
  }

  deactivateTax(id) {
    return this.http.get(this.signupUrl + `/deactivateTax/${id}/`);
  }

  deletTax(id) {
    return this.http.delete(this.signupUrl + `/${id}/deleteTax`);
  }

  fetchsalesPersonTeams(id?) {
    const salesID = id ? id : this.user ? this.user.id : 0;
    const orgId = this.org && this.org.id ? this.org.id : 0;
    const type = 1;
    const req = this.http.get(
      this.peopleUrl + `/getAllTeamsByMemberIds/${salesID}/${orgId}/${type}`
    );
    return this.mapTeamSelf(req);
  }

  fetchSupervisorTeams() {
    const type = 1;
    const req = this.http.get(this.signupUrl + `/getSubordinates/${this.org.id}/${this.user.email}`).pipe(map((res: any) => {
      let supervisorIds = [];
      res.forEach((element) => {
        supervisorIds.push(element.id);
      });
      supervisorIds.push(this.user.id);
      return supervisorIds.toString();
    }),
      mergeMap((supervisorId) =>
        this.http.get(
          this.peopleUrl +
          `/getAllTeamsByMemberIds/${supervisorId}/${this.org.id}/${type}`
        )
      )
    );
    return this.mapTeamSelf(req, { appendAll: true });
  }

  fetchSelfTeams(userId, orgId): Observable<any> {
    const userIdx = userId || this.user.id;
    const orgIdx = orgId || this.org.id;
    return this.http.get(
      this.peopleUrl + `/getAllTeamsByMemberIds/${userIdx}/${orgIdx}/2`
    );
  }

  mapTeamSelf(
    observable: Observable<any>,
    options?: { appendAll?: boolean; teamIdKey?: string }
  ) {
    const _appendAll = options && options.appendAll ? options.appendAll : false;
    const id = options && options.teamIdKey ? options.teamIdKey : "teamID";
    return observable.pipe(
      mergeMap((data: any[]) => {
        const mappedData = data
          ? data.map((dat) => {
            if (dat.id == this.user.teamID) {
              return {
                [id]: dat.id,
                teamName: "Self",
              };
            } else {
              if (dat.self === 1) {
                const teamname = dat.teamName.split(" ");
                return {
                  [id]: dat.id,
                  teamName: `${teamname[0]} ${teamname[1]} Team`,
                };
              } else {
                return { teamID: dat.id, teamName: dat.teamName };
              }
            }
          })
          : [];
        const result = _appendAll
          ? [{ [id]: "All", teamName: "All" }, ...mappedData]
          : mappedData;
        return of(result);
      })
    );
  }

  fetchLicenseByName(plan?) {
    const orgPlan = plan ? plan : this.org.plan;
    const headers = this.gs.getCommandCenterHeaders();
    return this.http.get(this.adminApi + `/${orgPlan}/getLicenseByName`,{headers});
  }
  getLicenseFromBilling() {
    const headers = this.gs.getCommandCenterHeaders();
    return this.http.get(
      this.adminApi + `/${this.org.id}/getLicenseFromBilling`,{headers}
    );
  }
  getUserById(id) {
    return this.http.get(`${this.signupUrl}/getUser/${id}`);
  }
  getOneUser(id) {
    try {
      return this.http
        .get(`${this.getOneUserUrl}/${id}`)
        .pipe(catchError(this.handleError));
    } catch (error) {
      alert(error);
    }
  }
  addSupervisor(payload: any[]) {
    const body = { orgID: this.org.id, userIDs: payload.map((x) => x.id) };
    return this.http.post(this.signupUrl + "/addSupervisor", body);
  }
  fetchSupervisor() {
    return this.http.get(this.signupUrl + "/getSupervisors/" + this.org.id).pipe(mergeMap((data: any[])=>{
      return of(data);
    }));
  }

  deleteSupervisor(superEmail) {
    return this.http.delete<any>(
      this.signupUrl + `/${this.org.id}/${superEmail}/deleteSupervisor`
    );
  }


  addSubordinate({ supervisorEmail, userEmails }) {
    const body = {
      orgID: this.org.id,
      supervisorEmail,
      userEmails: userEmails.map((x) => x.email),
    };
    return this.http.post(this.signupUrl + "/addSubordinate", body);
  }
  fetchSubordinates(email): Observable<any> {
    return this.http.get(
      this.signupUrl + `/getSubordinates/${this.org.id}/${email}`
    );
  }

  fetchSubordinatesSalesperson(email): Observable<any> {
    return this.http.get(
      this.signupUrl + `/getSubordinatesForMobile/${this.org.id}/${email}`
    );
  }

  /**
   * Fetchs task subordinates
   * @param email
   * @returns task subordinates
   *  Fetch full subordinates information
   */
  fetchTaskSubordinates(email): Observable<any> {
    return this.http.get(
      this.signupUrl + `/getTaskSubordinates/${this.org.id}/${email}`
    ).pipe(
      map((res: any) => {
        return res.map((result) => {
          const { user, userRel } = result;
          let response = {
            ...user,
            salesPerson: `${userRel.salesPerson}`,
            fullName: `${user.firstName} ${user.lastName}`,
          };
          return response
        });
      })
    );
  }

  deleteSubordinate(superEmail, subEmail) {
    return this.http.delete(
      this.signupUrl +
      `/${this.org.id}/${superEmail}/${subEmail}/deleteSubordinate`
    );
  }

  searchUsers(value) {
    return this.http.get(
      this.signupUrl + `/users/search/${value}/${this.org.id}`
    );
  }

  successLoginActionSrv(data) {
    const plan = data && data.organization && data.organization.plan ? data.organization.plan : "";
    const getTeamId = this.fetchSelfTeams(data.user.id, data.organization.id);
    let getModules = null;
    if (data.userRel && data.userRel.assignedLicense) {
      const { userID, orgID } = data.userRel;
      getModules = this.fetchUserLicenseWithAllModulesAndResources(orgID, userID);
    } else {
      getModules = this.fetchLicenseByName(plan);
    }

    // License expiry check is now handled by startLicenseExpiryWatcher() in app.component.ts
    // which uses the new getUserLicensesAcrossOrgs endpoint

    return this.getApiKey(data.organization).pipe(mergeMap((apiKeyRes) => {
      const apiKey = apiKeyRes.payload.key;
      this.authSrv.updateUserAndOrg({ apiKey });
      return forkJoin([getTeamId, getModules]).pipe(map(([team, modulex]) => {
        const teamID = team.length ? team[0].id : 0;
        const modules = (modulex as any).modules;
        const resources = (modulex as any).resources;
        return { teamID, modules, apiKey, resources };
      }));
    }));
  }


  getApiKey(org?) {
    const newOrg = org ? org : {};
    const { id: orgId } = newOrg;
    return this.http.get<any>(`${this.keysUrl}/${orgId || this.org.id}`)
      .pipe(catchError((err) => {
        const statusCode = err.error.status_code;
        if (statusCode == 404) {
          this.createApiKey(org).subscribe(res => { }
          )
        }
        return throwError(err);
      }))

  }
  createApiKey(org?) {
    const newOrg = org ? org : {};
    const { id, name } = newOrg;
    const payload = { id: id || this.org.id, name: name || this.org.name };
    return this.http.post<any>(`${this.keysUrl}`, payload);
  }

  fetchUserLicenseWithAllModulesAndResources(orgID, userID) {
    const headers = this.gs.getCommandCenterHeaders();
    return this.http.get(this.adminApi + `/getAllUserResourcesAndModules/${orgID}/${userID}`, {headers});
  }

  // Get all licenses for a user across all organizations
  getUserLicensesAcrossOrgs(userId: number, page: number = 0, size: number = 100): Observable<any> {
    const headers = this.gs.getCommandCenterHeaders();
    return this.http.get(`${this.adminApi}/getUserLicensesAcrossOrgs/${userId}?page=${page}&size=${size}`, { headers });
  }

  // Parse date string that may have single-digit month/day/time components
  // Handles formats like "2026-1-29 12:27:7" or "2027-02-03 16:20:22"
  private parseLicenseExpiryDate(dateStr: string): Date | null {
    if (!dateStr) return null;

    try {
      // Split into date and time parts
      const [datePart, timePart] = dateStr.split(' ');
      if (!datePart) return null;

      const dateParts = datePart.split('-');
      if (dateParts.length !== 3) return null;

      const year = parseInt(dateParts[0], 10);
      const month = parseInt(dateParts[1], 10);
      const day = parseInt(dateParts[2], 10);

      let hours = 0, minutes = 0, seconds = 0;
      if (timePart) {
        const timeParts = timePart.split(':');
        hours = parseInt(timeParts[0], 10) || 0;
        minutes = parseInt(timeParts[1], 10) || 0;
        seconds = parseInt(timeParts[2], 10) || 0;
      }

      // Create date using components (month is 0-indexed in JS Date)
      return new Date(year, month - 1, day, hours, minutes, seconds);
    } catch (e) {
      return null;
    }
  }

  // Check license status for a user - returns detailed license info
  // Returns object with: hasActiveInCurrentOrg, hasActiveInOtherOrg, allExpired, neverAssignedLicense, licenses
  checkLicenseStatus(userId: number, currentOrgId: string, isInternalGroup: boolean = false): Observable<{
    hasActiveInCurrentOrg: boolean;
    hasActiveInOtherOrg: boolean;
    allExpired: boolean;
    neverAssignedLicense: boolean;
    activeOtherOrgs: any[];
    licenses: any[];
  }> {
    if (isInternalGroup) {
      return of({
        hasActiveInCurrentOrg: true,
        hasActiveInOtherOrg: false,
        allExpired: false,
        neverAssignedLicense: false,
        activeOtherOrgs: [],
        licenses: []
      });
    }

    return this.getUserLicensesAcrossOrgs(userId).pipe(
      map((res: any) => {
        const result = {
          hasActiveInCurrentOrg: false,
          hasActiveInOtherOrg: false,
          allExpired: true,
          neverAssignedLicense: false, // From backend: userHasNeverBeenAssignedToLicense
          activeOtherOrgs: [] as any[],
          licenses: [] as any[]
        };

        if (res && res.statusCode === 200 && res.payload) {
          // Use backend flag to determine if user has never been assigned a license
          if (res.payload.userHasNeverBeenAssignedToLicense === true) {
            result.neverAssignedLicense = true;
          }

          if (Array.isArray(res.payload.content)) {
            const licenses = res.payload.content;
            result.licenses = licenses;

            const now = new Date();
            const currentOrgIdStr = String(currentOrgId);

            for (const license of licenses) {
              // Check if license is active (not expired and status is Running)
              let isActive = false;
              if (license.expiryDate && license.status === 'Running') {
                const expiryDate = this.parseLicenseExpiryDate(license.expiryDate);
                if (expiryDate && !isNaN(expiryDate.getTime())) {
                  isActive = now < expiryDate;
                }
              }

              if (isActive) {
                result.allExpired = false;
                const licenseOrgId = String(license.tenantID);

                if (licenseOrgId === currentOrgIdStr) {
                  result.hasActiveInCurrentOrg = true;
                } else {
                  result.hasActiveInOtherOrg = true;
                  // Add to activeOtherOrgs if not already present
                  if (!result.activeOtherOrgs.find(o => String(o.tenantID) === licenseOrgId)) {
                    result.activeOtherOrgs.push({
                      tenantID: license.tenantID,
                      tenantName: license.tenantName
                    });
                  }
                }
              }
            }
          }
        }

        return result;
      }),
      catchError(() => of({
        hasActiveInCurrentOrg: true, // On error, don't log out user
        hasActiveInOtherOrg: false,
        allExpired: false,
        neverAssignedLicense: false,
        activeOtherOrgs: [],
        licenses: [],
        error: true
      }))
    );
  }

  startLicenseExpiryWatcher() {
    // Prevent duplicate intervals
    if (this.licenseExpiryWatcherStarted) return;
    this.licenseExpiryWatcherStarted = true;

    setInterval(() => {
      const user = this.gs.user;
      const org = this.gs.org;
      const token = this.gs.token;
      const userRel = this.gs.userRel;
      const isInternalGroup = !!(userRel && userRel.internalGroup === true);

      // Skip if user is not logged in or data not available
      if (!user || !user.id || !org || !org.id || !token) return;

      if (isInternalGroup) return;

      // Skip if user is on login page, auth pages, or license purchase pages
      const currentPath = window.location.pathname;
      if (currentPath.includes('/login') || currentPath.includes('/signup') ||
          currentPath.includes('/forgot-password') || currentPath.includes('/reset-password') ||
          currentPath.includes('/complete-signup') || currentPath.includes('/create-organization') ||
          currentPath.includes('/reg/plans') || currentPath.includes('/reg/org') ||
          currentPath.includes('/reg/register') || currentPath.includes('/reg/verify')) {
        return;
      }

      // Check if localStorage still has user data (not logged out by inactivity)
      const currentUser = localStorage.getItem('currentUser');
      if (!currentUser) {
        return;
      }

      this.checkLicenseStatus(user.id, String(org.id), isInternalGroup).subscribe((status) => {
        // Don't log out if there was an API error
        if ((status as any).error) {
          return;
        }

        // Double-check user is still logged in before logging out
        const stillLoggedIn = localStorage.getItem('currentUser');
        if (!stillLoggedIn) {
          return;
        }

        // If user has never been assigned a license (new user), redirect to purchase page instead of logout
        if (status.neverAssignedLicense) {
          console.log('User has never been assigned a license - redirecting to license purchase page');
          window.location.href = '/reg/plans';
          return;
        }

        // Log out only if user HAD licenses but they are all expired in current org
        if (!status.hasActiveInCurrentOrg) {
          console.log('License expired - logging out user');
          localStorage.clear();
          sessionStorage.clear();
          const isSuperAdmin = this.gs.roleName === 'Super Admin';
          if (isSuperAdmin) {
            window.location.href = '/login?expired=true&superadmin=true';
          } else {
            window.location.href = '/login?expired=true';
          }
        }
      });
    }, 30000); // Check every 30 seconds
  }


}
